var exports = {
  "l": "ShieldIcon__e-G_Hk",
};

module.exports = exports;
